import { useApp } from "../context/AppContext";
import { Home, Grid, Award, User } from "./Icons";
import { MapPin } from "lucide-react";
import NavItem from "./bottom-nav/NavItem";

interface BottomNavProps {
  onTabClick?: () => void;
  isScrolling?: boolean;
}

export default function BottomNav({ onTabClick, isScrolling }: BottomNavProps) {
  const { theme } = useApp();
  const isDark = theme === "dark";

  const navs = [
    { key: "home", en: "Home", bn: "হোম", Icon: Home },
    { key: "track", en: "Track", bn: "ট্র্যাকিং", Icon: MapPin },
    { key: "categories", en: "Categories", bn: "ক্যাটাগরি", Icon: Grid },
    { key: "deals", en: "Deals", bn: "অফার", Icon: Award },
    { key: "orders", en: "Account", bn: "অ্যাকাউন্ট", Icon: User },
  ];

  return (
    <div
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
      className={`fixed bottom-2 sm:bottom-4 left-0 right-0 z-[180] px-2 sm:px-4 flex lg:hidden justify-center pointer-events-none select-none transition-transform duration-350 ease-in-out ${isScrolling ? "translate-y-24" : "translate-y-0"}`}
    >
      <div
        className={`flex items-center justify-between w-full max-w-md bg-white/90 dark:bg-[#121215]/90 backdrop-blur-xl border border-neutral-200/50 dark:border-white/10 shadow-lg px-1.5 sm:px-3 py-1.5 rounded-[24px] pointer-events-auto transition-all duration-300`}
      >
        {navs.map((nav) => (
          <NavItem
            key={nav.key}
            navKey={nav.key}
            en={nav.en}
            bn={nav.bn}
            Icon={nav.Icon}
            onTabClick={onTabClick}
          />
        ))}
      </div>
    </div>
  );
}
